import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BsCheck2Circle } from "react-icons/bs";
import AuthService from "../../services/auth.service";

export const PaymentSuccessPage = () => {
  const navigate = useNavigate();
  const [orderInfo, setOrderInfo] = useState(null);
  const isBusiness = AuthService.getCurrentUser()?.user?.businesses?.length > 0;

  useEffect(() => {
    // Read stored order info and fire Google Ads conversion
    const stored = localStorage.getItem("parcelin_pending_order");
    if (stored) {
      const info = JSON.parse(stored);
      setOrderInfo(info);

      if (window.gtag) {
        window.gtag("event", "conversion", {
          send_to: "AW-17797671666/RK0XCMLz888cEPLVy6ZC",
          value: info.value,
          currency: "ZAR",
          transaction_id: info.reference,
        });
      }

      localStorage.removeItem("parcelin_pending_order");
    } else {
      // No stored order — still fire conversion with default value
      if (window.gtag) {
        window.gtag("event", "conversion", {
          send_to: "AW-17797671666/RK0XCMLz888cEPLVy6ZC",
          value: 1.0,
          currency: "ZAR",
          transaction_id: "",
        });
      }
    }
  }, []);

  return (
    <div className="w-full min-h-[60vh] flex flex-col items-center justify-center p-5">
      <div className="bg-white rounded-2xl border border-green-200 shadow-sm p-8 max-w-md w-full text-center">
        <BsCheck2Circle className="text-green-500 mx-auto mb-4" size={64} />
        <h1 className="text-2xl font-extrabold text-gray-900 mb-2">
          Payment Successful!
        </h1>
        <p className="text-gray-600 mb-6">
          Thank you for your order. Your parcel is being processed.
        </p>

        {orderInfo && (
          <div className="bg-gray-50 rounded-xl p-4 mb-6 text-left">
            <div className="flex justify-between text-sm mb-2">
              <span className="text-gray-500">Amount Paid</span>
              <span className="font-bold text-gray-800">R{orderInfo.value}</span>
            </div>
            {orderInfo.reference && (
              <div className="flex justify-between text-sm">
                <span className="text-gray-500">Reference</span>
                <span className="font-bold text-gray-800">{orderInfo.reference}</span>
              </div>
            )}
          </div>
        )}

        <button
          onClick={() => navigate(isBusiness ? "/business/dashboard" : "/parcels")}
          className="w-full bg-purple-600 hover:bg-purple-700 text-white font-bold py-3 rounded-xl transition-all"
        >
          View My Orders
        </button>
      </div>
    </div>
  );
};
